import { motion } from "framer-motion";

export const PageHero = ({ eyebrow, title, script }) => (
  <section className="bg-ink text-[#f2f0ea] pt-[160px] pb-16" data-testid="page-hero">
    <div className="max-w-[1280px] mx-auto px-5 lg:px-8">
      {eyebrow && <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="text-xs tracking-[0.3em] text-gold font-semibold mb-3">{eyebrow}</motion.p>}
      <div className="overflow-hidden">
        <motion.h1 initial={{ y: "110%" }} animate={{ y: 0 }} transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.95]">{title}</motion.h1>
      </div>
      {script && <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3 }} className="font-script text-gold text-4xl sm:text-5xl mt-2">{script}</motion.p>}
    </div>
  </section>
);
